import { PATH_SNAP_STICKS_DETAILS } from '@farmersdog/constants/paths';

export function formatPdpURL(entireProductName: string, productSize: string) {
  const proteinName = entireProductName.replace(/ .*/, '');

  return `${PATH_SNAP_STICKS_DETAILS}?recipe=${proteinName}&size=${productSize}`;
}
